<template>
  <section class="_container">
    <div class="_full">
      <h2>URL bygger</h2>
      <p>Her kan du bygge en URL med et forhåndsdefinert filter for boliger.</p>
    </div>
    <div>
      <div>
        <h3>Bygg</h3>
        <p>Velg bygg</p>
        <label
          :class="{
            'is-active': selectedBuilding === 'all',
          }"
          for="building-all"
          class="c-btn c-btn--invisible"
        >
          <Toggle
            :isSelected="selectedBuilding === 'all'"
            class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
          />
          Alle
          <input
            id="building-all"
            v-model="selectedBuilding"
            type="radio"
            value="all"
            class="screen-reader-text"
          >
        </label>
        <label
          v-for="building in buildings"
          :key="building.id"
          :for="'building-' + building.slug"
          :class="{
            'is-active': selectedBuilding === building.id,
          }"
          class="c-btn c-btn--invisible"
        >
          <Toggle
            :isSelected="selectedBuilding === building.id"
            class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
          />
          {{ building.name }}
          <input
            :id="'building-' + building.slug"
            v-model="selectedBuilding"
            :value="building.id"
            type="radio"
            class="screen-reader-text"
          >
        </label>
      </div>
      <div>
        <h3>Salgsstatus</h3>
        <p>Velg salgsstatus</p>
        <label 
          :class="{
            'is-active': availabilityState === 'all',
          }"
          for="availability-all"
          class="c-btn c-btn--invisible"
        >
          <Toggle
            :isSelected="availabilityState === 'all'"
            class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
          />
          Alle
          <input
            id="availability-all"
            v-model="availabilityState"
            value="all"
            type="radio"
            class="screen-reader-text"
          >
        </label>
        <label
          v-for="availability in availabilities"
          :key="availability.id"
          :for="'availability-' + availability.slug" 
          :class="{
            'is-active': availabilityState === availability.slug,
          }"
          class="c-btn c-btn--invisible"
        >
          <Toggle
            :isSelected="availabilityState === availability.slug"
            class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
          />
          {{ availability.name }}
          <input
            :id="'availability-' + availability.slug"
            v-model="availabilityState"
            :value="availability.slug"
            type="radio"
            class="screen-reader-text"
          >
        </label>
      </div>

      <div>
        <h3>Pris</h3>
        <p>Velg pris fra – til</p>
        <filter-price-input />
      </div>

      <div>
        <h3>Størrelse</h3>
        <p>Velg størrelse fra – til</p>
        <label for="minSizeInput">Fra m²:
          <input
            id="minSizeInput"
            v-model="minSize"
            type="number"
          >
        </label>
        <label for="maxSizeInput">Til m²:
          <input
            id="maxSizeInput"
            v-model="maxSize"
            type="number"
          >
        </label>
      </div>

      <div>
        <h3>Sortering</h3>
        <p>Velg ønsket sortering</p>
        <sorter />
      </div>

      <div>
        <h3>Soverom</h3>
        <p>Velg antall soverom</p>
        <select-bedrooms />
      </div>

      <div>
        <h3>Bad</h3>
        <p>Velg antall bad</p>
        <select-bathrooms />
      </div>

      <!--
        Filter for levels virker ikke for tiden.
        <div>
        <h3>Nivå</h3>
        <p>Velg bolignivå</p>
        <label
          :class="{
            'is-active': selectedLevel === 'all',
          }"
          for="level-all"
          class="c-btn c-btn--invisible"
        >
          <Toggle
            :isSelected="selectedLevel === 'all'"
            class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
          />
          Alle
          <input
            id="level-all"
            v-model="selectedLevel"
            :value="'all'"
            type="radio"
            class="screen-reader-text"
          >
        </label>
        <label
          v-for="level in levels"
          :key="level.id"
          :for="'level-' + level.slug"
          :class="{
            'is-active': selectedLevel === level.slug,
          }"
          class="c-btn c-btn--invisible"
        >
          <Toggle
            :isSelected="selectedLevel === level.id"
            class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
          />
          {{ level.name }}
          <input
            :id="'level-' + level.slug"
            v-model="selectedLevel"
            :value="level.id"
            type="radio"
            class="screen-reader-text"
          >
        </label>
      </div>-->

      <div>
        <h3>Boligtype</h3>
        <p>Velg type bolig</p>
        <label
          :class="{
            'is-active': selectedResidenceType === 'all',
          }"
          for="type-all"
          class="c-btn c-btn--invisible"
        >
          <Toggle
            :isSelected="selectedResidenceType === 'all'"
            class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
          />
          Alle
          <input
            id="type-all"
            v-model="selectedResidenceType"
            :value="'all'"
            type="radio"
            class="screen-reader-text"
          >
        </label>
        <label
          v-for="type in residenceTypes"
          :key="type.id"
          :for="'type-' + type.slug"
          :class="{
            'is-active': selectedResidenceType === type.slug,
          }"
          class="c-btn c-btn--invisible"
        >
          <Toggle
            :isSelected="selectedResidenceType === type.slug"
            class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
          />
          {{ type.name }}
          <input
            :id="'type-' + type.slug"
            v-model="selectedResidenceType"
            :value="type.slug"
            type="radio"
            class="screen-reader-text"
          >
        </label>
      </div>
    </div>
    <div>
      <div class="_sticky">
        <residence-list />
        <residence-counter />
        <button
          @click="queryURL"
          class="c-btn c-btn--primary"
        >
          Gå til URL
        </button>
      </div>
    </div>
  </section>
</template>

<script>
// Data models
import Availability from '@/models/Availability';
import Building from '@/models/Building';
import Residence from '@/models/Residence';
import Level from '@/models/Level';
import ResidenceType from '@/models/ResidenceType';

// Components
import FilterPriceInput from '@/components/FilterPriceInput.vue';
import ResidenceCounter from '@/components/ResidenceCounter.vue';
import ResidenceList from '@/components/ResidenceList.vue';
import SelectBathrooms from '@/components/SelectBathrooms.vue';
import SelectBedrooms from '@/components/SelectBedrooms.vue';
import Sorter from '@/components/Sorter.vue';
import Toggle from '@/components/Toggle.vue';


export default {
  name: 'UrlBuilder',
  components: {
    FilterPriceInput,
    ResidenceCounter,
    ResidenceList,
    SelectBathrooms,
    SelectBedrooms,
    Sorter,
    Toggle,
  },
  computed: {
    buildings() {
      return Building.all();
    },
    availabilities() {
      return Availability.all();
    },
    levels() {
      return Level.all();
    },
    residenceTypes() {
      return ResidenceType.all();
    },
    bedroomState() {
      return this.$store.state.entities.residences.bedrooms;
    },
    bathroomState() {
      return this.$store.state.entities.residences.bathrooms;
    },
    order() {
      return this.$store.state.entities.residences.order;
    },
    selectedBuilding: {
      get() {
        return this.$store.state.entities.buildings.selectedBuilding;
      },
      set(selectedBuilding) {
        Building.commit(state => {
          state.selectedBuilding = selectedBuilding;
        });
      },
    },
    availabilityState: {
      get() {
        return this.$store.state.entities.residences.residenceStatus;
      },
      set(availability) {
        Residence.commit(state => {
          state.residenceStatus = availability;
        });
      },
    },
    selectedLevel: {
      get() {
        return this.$store.state.entities.residences.selectedLevel;
      },
      set(selectedLevel) {
        Residence.commit(state => {
          state.selectedLevel = selectedLevel;
        });
      },
    },
    selectedResidenceType: {
      get() {
        return this.$store.state.entities.residences.selectedResidenceType;
      },
      set(selectedResidenceType) {
        Residence.commit(state => {
          state.selectedResidenceType = selectedResidenceType;
        });
      },
    },
    minPrice() {
      return this.$store.state.entities.residences.minPrice;
    },
    maxPrice() {
      return this.$store.state.entities.residences.maxPrice;
    },
    minSize: {
      get() {
        return this.$store.state.entities.residences.minSize;
      },
      set(minSize) {
        Residence.commit(state => {
          state.minSize = parseInt(minSize);
        });
      },
    },
    maxSize: {
      get() {
        return this.$store.state.entities.residences.maxSize;
      },
      set(maxSize) {
        Residence.commit(state => {
          state.maxSize = parseInt(maxSize);
        });
      },
    },
    query() {
      let query = {};
      if (isNaN(this.minPrice) === false && this.minPrice != 0) {
        query.minprice = this.minPrice;
      }
      if (this.maxPrice != 0 && isNaN(this.maxPrice) === false) {
        query.maxprice = this.maxPrice;
      }
      if (isNaN(this.minSize) === false && this.minSize != 0) {
        query.minsize = this.minSize;
      }
      if (isNaN(this.maxSize) === false && this.maxSize != 0) {
        query.maxsize = this.maxSize;
      }
      if (this.selectedBuilding != 'all') {
        query.building = this.selectedBuilding;
      }
      if (this.residenceStatus != 'all') {
        query.availability = this.residenceStatus;
      }
      if (this.bedroomState.length > 0) {
        query.bedrooms = this.bedroomState;
      }
      if (this.bathroomState.length > 0) {
        query.bathrooms = this.bathroomState;
      }
      if (this.selectedResidenceType != 'all') {
        query.type = this.selectedResidenceType;
      }
      return query;
    },
  },
  methods: {
    queryURL() {
      this.$router.push({
        path: '/',
        query: this.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// FIXME: Hacky og crappy css, trenger en reall opprydding.

._container {
  display: grid;
  gap: 1em;
  grid-template-columns: 1fr 1fr;
}

._full {
  grid-column: 1 / -1;
}

._sticky {
  position: sticky;
  top: 10em;
}

div {
  margin-bottom: 3em;
}

input {
  display: inline-block;
  width: auto;
}

label {
  margin-right: 1em;
}
</style>